<template>
    <div class="container">
        
        <div class="col-12 pb-4">
            <div class="font-glacial-regular row d-box align-items-center text-center">
                <b-form-input class="form-search font-45 search-padding" size="lg" v-model="text1" @input="searchDebounce" type="text" placeholder="  buscar">
                </b-form-input>
            </div>
        </div>

        <div class="pt-3 row justify-content-center d-none d-xl-flex">
            <div class="pt-xl-5 pt-4 pb-xl-0 pb-4" v-for="(d, index) in cursosOrdened" :key="index">
                <span :class="['font-glacial-bold text-uppercase font-18 pr-3 btn-pointer', d == area ? 'active' : '']" @click="changeCourse(d)">
                    {{d}}
                </span>
            </div>
        </div>

        <div class="row eventos mb-xl-5 btn-pointer">
            <div class="mt-xl-4 pt-3 pt-xl-0 col-xl-4 mb-3" v-for="(d, index) in cursosSpliced" :key="index">
                <div class="mt-xl-5">
                    <div class="blog-item border-transparent border-radius-0 clickable" @click="routeTo({name:'curso', params:{slug:d.slug, area: d.area}})">
                        <div class="card-body card text-white card-cursos p-0 border-0 border-radius-0"
                            :style="`background-image: url(${d.imagem})`" >
                        </div>
                        <div class="row no-gutters text-overflow">
                            <div class="col-xl-11 col-10 bg-white box-curso">
                                <h5 class="extra-bold mt-3 ml-3 mb-0 font-glacial-bold box-titulo">
                                    {{d.nome}}
                                </h5>
                                <div class="arrow ml-3 mt-4 mb-4">
                                    <img src="/wp-content/themes/rhiza\src/assets/arrow.png">
                                </div>
                                <div>
                                    <div class="font-glacial-regular ml-3 descricao-curso">
                                        {{d.descricao}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    

    </div>
</template>
<script>

export default {

    data(){
        return{
            indexData: 9,
            text1: '',
            area: '',
            curso: '',
            title: '',
            scrollPercentage: 0,
            loading: false,
        }
    },

    watch: {
        '$route.query.slug': 'setArea'
    },

    methods:{
        setArea(){
            if(this.$route.params.area){
                this.area = this.$route.params.area

                if (this.area) {
                    this.title = this.area.replace(new RegExp('-', 'g'), ' ');
                    var arrTitle = document.title.split('|');
                    var [baseTitle] = arrTitle.slice(-1);
                    var d = document.createElement('div');
                    d.innerHTML =  `${this.titleCase(this.title)} | ${baseTitle}`
                    document.title = d.innerText
                }
            }
        },

        searchDebounce: _.debounce(function() {
            this.curso = this.text1.toUpperCase()
        }, 200),

        changeCourse(area) {
            this.area = area
            this.text1 = ''

            if (this.area) {
                var aux = document.title.split('|')
                this.title = this.area.replace(new RegExp('-', 'g'), ' ');
                document.title = `${this.titleCase(this.title)} | ${aux[aux.length - 1]}`
            }

            window.history.pushState(null, this.area, `/cursos/${this.area}`);
        },

        cursosClicked(){
            if(this.clicked == false){
                this.clicked = true
                document.querySelector('body').classList.add('body-overflow')
            } else {
                this.clicked = false
                document.querySelector('body').classList.remove('body-overflow')
            }
        },

        routeTo(obj){
            this.cursosClicked()
            this.$router.push(obj)
        },

        titleCase(str) {
            var splitStr = str.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                // You do not need to check if i is larger than splitStr length, as your for does that for you
                // Assign it back to the array
                if (splitStr[i].length > 2) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
            }
            // Directly return the joined string
            return splitStr.join(' '); 
        }

    },

    created(){
       this.setArea()
    },

    mounted() {
        var self = this
        window.addEventListener("scroll", function(e){
            var h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';

            self.scrollPercentage = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100
        
            if(self.scrollPercentage >= 75){
                self.indexData += 6
            }
        })

    },

    computed:{
        cursosSpliced(){
            return this.cursos.slice(0, this.indexData)
        },

        cursos(){
            if(!this.$store.state.post.cursosApi || !this.$store.state.post.cursosApi.length){
                return []
            }

            if(this.text1){
                return this.$store.state.post.cursosApi.filter(o => o.nome.includes(this.curso))
            }

            if(!this.area){
                return this.$store.state.post.cursosApi
            }

            return this.$store.state.post.cursosApi.filter(o => o.area == this.area)
        },
        cursosOrdened(){
            if(!this.$store.state.post.cursosApi){
                return []
            }

            return Array.from(new Set(this.$store.state.post.cursosApi.map(e => e.area)))
        },
    }
}
</script>
<style scoped>
.active {
    color: #F56F4D;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/cursos.vue